import { oc } from 'ts-optchain';
import { createReducer } from '@reduxjs/toolkit';
import { Nullable } from 'modules/types/common';
import * as actions from './actions';
import { ProviderFacets, ProviderSpecialty } from './types';

export type FacetsState = Readonly<{
  isFetching: boolean;
  error: Nullable<Error>;
  data: Nullable<ProviderFacets>;
  specialties: {
    isFetching: boolean;
    error: Nullable<Error>;
    data: ProviderSpecialty[];
  };
}>;

export const facetsInitialState: FacetsState = {
  isFetching: false,
  error: null,
  data: null,
  specialties: {
    isFetching: false,
    error: null,
    data: []
  }
};

export const facetsReducer = createReducer(facetsInitialState, {
  [actions.PROVIDER_FACETS]: state => {
    state.isFetching = true;
    state.error = null;
  },
  [actions.PROVIDER_FACETS_SUCCESS]: (state, action) => {
    state.isFetching = false;
    state.data = oc(action).payload.data(null);
  },
  [actions.PROVIDER_FACETS_FAIL]: (state, action) => {
    state.isFetching = false;
    state.error = action.error;
  },
  [actions.PROVIDER_SPECIALTIES]: state => {
    state.specialties.isFetching = true;
    state.specialties.error = null;
  },
  [actions.PROVIDER_SPECIALTIES_SUCCESS]: (state, action) => {
    state.specialties.isFetching = false;
    state.specialties.data = action.payload;
  },
  [actions.PROVIDER_SPECIALTIES_FAIL]: (state, action) => {
    state.specialties.isFetching = false;
    state.specialties.error = action.error;
  }
});
